import { render, staticRenderFns } from "./CreateOrdensTrabalho.vue?vue&type=template&id=32d63860&scoped=true"
import script from "./CreateOrdensTrabalho.vue?vue&type=script&lang=js"
export * from "./CreateOrdensTrabalho.vue?vue&type=script&lang=js"
import style0 from "./CreateOrdensTrabalho.vue?vue&type=style&index=0&id=32d63860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d63860",
  null
  
)

export default component.exports